var $f384df7b56bf53ca$exports = {};
(function() {
    'use strict';
    window.applyAccordion = {
        init: initApplyAccordion
    };
    function initApplyAccordion(root) {
        if (!root) return;
        var accordionRoot = root.querySelector('.accordion');
        if (!accordionRoot) return;
        var items = accordionRoot.querySelectorAll('.accordion__item');
        function clearActive() {
            items.forEach(function(item) {
                item.classList.remove('accordion__item--active');
            });
        }
        accordionRoot.addEventListener('shown.bs.collapse', function(event) {
            if (!root.contains(event.target)) return;
            clearActive();
            var item = event.target.closest('.accordion__item');
            if (item) item.classList.add('accordion__item--active');
            if (!event.target.hasAttribute('tabindex')) event.target.setAttribute('tabindex', '-1');
            event.target.focus({
                preventScroll: true
            });
        });
        accordionRoot.addEventListener('hidden.bs.collapse', function(event) {
            if (!root.contains(event.target)) return;
            var item = event.target.closest('.accordion__item');
            if (item) item.classList.remove('accordion__item--active');
            event.target.removeAttribute('tabindex');
        });
    }
})();


//# sourceMappingURL=accordion.js.map
